import { ComponentBootstrap, withReactBootstrap } from '@demant/react-bootstrap';
import imageSpotSchema from '@demant/react-bootstrap/lib/schemas/image-spot';
import ImageSpotAccordionComponent from './js/CustomAccordion';
import './js/AccordionSpotComponent';
var ReactTopBanner = new ComponentBootstrap('.image-spot.get-accordion-items');
ReactTopBanner.schemaData = imageSpotSchema;
ReactTopBanner.reactApp = withReactBootstrap(ImageSpotAccordionComponent);
ReactTopBanner.run();